import { connect } from 'react-redux';
import { isEmpty } from 'ramda';
import { MVKOrMap, IMVKOrMapProps } from '../../components/MVKOrMap';
import { IApplicationState } from '../../types/redux';
import { getGeoCoordinates, getSpecialPromo, hasNewbuildingMVK } from '../../selectors/newbuilding';

type TMVKOrMapStateProps = Pick<IMVKOrMapProps, 'hasNewbuildingMVK' | 'specialPromo' | 'hasCoords' | 'mapOptions'>;

export function mapStateToProps(state: IApplicationState): TMVKOrMapStateProps {
  return {
    specialPromo: getSpecialPromo(state),
    hasNewbuildingMVK: hasNewbuildingMVK(state),
    hasCoords: !isEmpty(getGeoCoordinates(state)),
    mapOptions: state.common.mapOptions,
  };
}

export const MVKOrMapContainer = connect(mapStateToProps)(MVKOrMap);
